/*eslint-disable*/
import React from "react";
import FormInput from "components/Wrappers/materialUIWrappers/components/FormInput";
import FormDropdown from "components/Wrappers/materialUIWrappers/components/FormDropDown";
import DatePicker from "components/Wrappers/materialUIWrappers/components/DatePicker";
import { Field } from "redux-form";
import {
  Card,
  Grid,
  FormControl,
  CardContent,
  CardHeader,
  withStyles
} from "@material-ui/core";

const required = value => (value ? undefined : "Required");

const requiredDropdown = value => {
  if (value === "validationError") {
    return "Required";
  } else if (value) {
    return undefined;
  } else {
    return "Required";
  }
};

const styles = () => ({});

class CC_healthInfo extends React.Component {
  componentDidMount(){
    this.props.scrollMeBar();
  }
  
  render() {
    const validate = [];
    validate.push(required);

    return (
      <Card className="contentWithStepper">
        <CardHeader title="Client Health Info" />
        <CardContent>
        <Grid container spacing={24}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <Field
                  name={"healthHeight"}
                  component={FormInput}
                  label={"Height (m)"}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <Field
                  name={"healthWeight"}
                  component={FormInput}
                  label={"Weight (kg)"}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <Field
                  name={"healthCurrentGp"}
                  component={FormInput}
                  label={"Current GP"}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <Field
                  name={"healthGpYears"}
                  component={FormInput}
                  label={"How many years your GP"}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <Field
                  name={"healthCurrentDentist"}
                  component={FormInput}
                  label={"Current dentist"}
                />
              </FormControl>
            </Grid>

          </Grid>
        </CardContent>
      </Card>
    );
  }
}

export default withStyles(styles)(CC_healthInfo);



// WEBPACK FOOTER //
// ./src/views/Clients/components/CC_healthInfo.jsx